import React, { useState, useEffect, useMemo } from 'react';
import { Popup } from 'devextreme-react/popup';
import { SelectBox } from 'devextreme-react/select-box';
import { TextBox } from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import ScrollView from 'devextreme-react/scroll-view';
import * as DinamicQueries from '../../api/DinamicsQuery';

const AsignarCanalPopup = ({ visible, onHide, canales = [], idStore = null, onSaveSuccess }) => {
    const [clientesEstablecimiento, setClientesEstablecimiento] = useState([]);
    const [tiposPorCliente, setTiposPorCliente] = useState({});
    const [storeTypes, setStoreTypes] = useState([]);
    const [loadingClientes, setLoadingClientes] = useState(false);
    const [loadingStoreTypes, setLoadingStoreTypes] = useState(false);
    const [saving, setSaving] = useState(false);
    const [busqueda, setBusqueda] = useState('');

    const clientesFiltrados = useMemo(() => {
        if (!busqueda || !busqueda.trim()) return clientesEstablecimiento;
        const term = String(busqueda).trim().toLowerCase();
        return clientesEstablecimiento.filter(
            (c) => (c.nombre || '').toLowerCase().includes(term)
        );
    }, [clientesEstablecimiento, busqueda]);

    useEffect(() => {
        if (!visible) return;
        setLoadingStoreTypes(true);
        DinamicQueries.getDataWithParameters('callProcedure', 'analytics/', {
            method: 'sp_get_store_type',
            params: {},
        })
            .then((response) => {
                const data = response?.data ?? [];
                setStoreTypes(Array.isArray(data) ? data : []);
            })
            .catch((err) => {
                console.error('Error al cargar tipos de establecimiento:', err);
                setStoreTypes([]);
            })
            .finally(() => setLoadingStoreTypes(false));
    }, [visible]);

    useEffect(() => {
        if (!visible || idStore == null || idStore === '') return;
        setLoadingClientes(true);
        DinamicQueries.getDataWithParameters('callProcedure', 'analytics/', {
            method: 'sp_type_store_for_client',
            params: { id_store: Array.isArray(idStore) ? idStore.join(',') : String(idStore) },
        })
            .then((response) => {
                const data = response?.data ?? [];
                console.log('clientes que pertenecen al establecimiento *' + idStore + '*:', data);
                const seen = new Set();
                const unique = [];
                (data || []).forEach((item) => {
                    const id = item?.ID_CLIENTE ?? item?.id_cliente;
                    const nombre = item?.CLIENTE ?? item?.cliente ?? '';
                    const idType = item?.ID_TYPE ?? item?.id_type ?? null;
                    if (id != null && !seen.has(id)) {
                        seen.add(id);
                        unique.push({ id, nombre, id_type: idType != null ? Number(idType) : null });
                    }
                });
                setClientesEstablecimiento(unique);
                const initial = unique.reduce(
                    (acc, c) => ({ ...acc, [c.id]: c.id_type ?? null }),
                    {}
                );
                setTiposPorCliente(initial);
            })
            .catch((err) => {
                console.error('Error al cargar clientes del establecimiento:', err);
                setClientesEstablecimiento([]);
                setTiposPorCliente({});
            })
            .finally(() => setLoadingClientes(false));
    }, [visible, idStore]);

    const handleTipoChange = (clienteId, value) => {
        setTiposPorCliente((prev) => ({ ...prev, [clienteId]: value }));
    };

    const handleGuardar = () => {
        if (idStore == null || idStore === '') return;
        const items = clientesEstablecimiento.map((c) => ({
            id_client: c.id,
            id_type: tiposPorCliente[c.id] ?? null,
        }));
        setSaving(true);
        DinamicQueries.getDataWithParameters('saveStoreTypeClients', 'analytics/', {
            id_store: Number(idStore),
            items,
        })
            .then((response) => {
                if (response?.data?.msg !== false) {
                    onSaveSuccess?.();
                    onHide();
                }
            })
            .catch((err) => {
                console.error('Error al guardar tipos por cliente:', err);
            })
            .finally(() => setSaving(false));
    };

    return (
        <Popup
            visible={visible}
            onHiding={onHide}
            showTitle={true}
            title="Asignar Canal por Cliente"
            showCloseButton={true}
            width="90%"
            maxWidth={900}
            height="85vh"
        >
            <div className="p-3 d-flex flex-column" style={{ height: '100%', minHeight: 0 }}>
                <p className="text-muted small mb-3">
                    Clientes que visitan este establecimiento. Asigne un canal a cada uno.
                </p>
                <div className="mb-3">
                    <TextBox
                        value={busqueda}
                        onValueChanged={(e) => setBusqueda(e.value ?? '')}
                        placeholder="Buscar cliente..."
                        mode="search"
                        showClearButton={true}
                        stylingMode="outlined"
                        width="100%"
                    />
                </div>
                {loadingClientes && <p className="text-muted small">Cargando clientes...</p>}
                <ScrollView
                    width="100%"
                    height="100%"
                    className="flex-grow-1"
                    showScrollbar="always"
                    scrollByContent={false}
                    style={{ minHeight: 200, flex: '1 1 0' }}
                >
                    <div className="d-flex flex-column gap-3 pr-2">
                        {clientesFiltrados.map((cliente) => (
                            <div
                                key={cliente.id}
                                className="d-flex align-items-center"
                                style={{ minHeight: 40, width: '100%' }}
                            >
                                <span
                                    className="fw-medium"
                                    style={{
                                        flex: '0 0 35%',
                                        maxWidth: '35%',
                                        textAlign: 'left',
                                        paddingRight: 8,
                                    }}
                                >
                                    {cliente.nombre}
                                </span>
                                <div
                                    style={{
                                        flex: '0 0 65%',
                                        maxWidth: '65%',
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <SelectBox
                                        dataSource={storeTypes}
                                        displayExpr="NAME"
                                        valueExpr="ID"
                                        value={tiposPorCliente[cliente.id] ?? cliente.id_type ?? null}
                                        onValueChanged={(e) => handleTipoChange(cliente.id, e.value)}
                                        placeholder={loadingStoreTypes ? 'Cargando tipos...' : 'Seleccione tipo'}
                                        label="Tipo"
                                        labelMode="static"
                                        style={{ width: '100%', maxWidth: 320 }}
                                        searchEnabled
                                        showClearButton
                                        disabled={loadingStoreTypes}
                                    />
                                </div>
                            </div>
                        ))}
                        {!loadingClientes && clientesEstablecimiento.length === 0 && (
                            <p className="text-muted small">No hay clientes para este establecimiento o no se ha indicado ID.</p>
                        )}
                        {!loadingClientes && clientesEstablecimiento.length > 0 && clientesFiltrados.length === 0 && (
                            <p className="text-muted small">Ningún cliente coincide con la búsqueda.</p>
                        )}
                    </div>
                </ScrollView>
                <div className="d-flex justify-content-end gap-2 mt-3 pt-3 flex-shrink-0" style={{ borderTop: '1px solid #eee' }}>
                    <Button text="Cancelar" onClick={onHide} disabled={saving} />
                    <Button text="Guardar" type="default" onClick={handleGuardar} disabled={saving} />
                </div>
            </div>
        </Popup>
    );
};

export default AsignarCanalPopup;
